/**
 * IP白名单校验工具
 * 提供IP地址格式验证和白名单校验功能
 */

/**
 * 校验IP地址格式
 * @param {string} ip - 待校验的IP地址
 * @returns {boolean} 是否为合法IPv4格式
 */
const isValidIP = (ip) => {
  const ipv4Pattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  return ipv4Pattern.test(ip);
};

/**
 * 将IP地址转换为32位整数
 * @param {string} ip - IPv4地址
 * @returns {number} 32位整数表示的IP
 */
const ipToInt = (ip) => {
  return ip.split('.').reduce((acc, octet) => (acc << 8) + parseInt(octet, 10), 0) >>> 0;
};

/**
 * 检查IP是否在白名单内
 * @param {string} ip - 待检查的IP地址
 * @param {Array<string>} whitelist - IP白名单数组(支持CIDR格式)
 * @returns {boolean} 是否在白名单中
 */
export const isIPInWhitelist = (ip, whitelist) => {
  if (!isValidIP(ip)) return false;
  
  const ipInt = ipToInt(ip);
  
  for (const entry of whitelist) {
    if (entry.includes('/')) {
      // CIDR格式处理
      const [subnet, prefix] = entry.split('/');
      const subnetInt = ipToInt(subnet);
      const mask = ~(0xFFFFFFFF >>> parseInt(prefix));
      
      if ((ipInt & mask) === (subnetInt & mask)) {
        return true;
      }
    } else {
      // 直接IP匹配
      if (isValidIP(entry) && entry === ip) {
        return true;
      }
    }
  }
  
  return false;
};



/**
 * 获取当前设备的IP地址
 * @returns {Promise<string>} 返回包含IP地址的Promise
 */
export function getLocalIP() {
  return "192.168.1.120"
}


// 更新后的使用示例:
// import { isIPInWhitelist, getLocalIP } from '@/utils/ipConfigUtils';
// const whitelist = ['192.168.1.1', '10.0.0.0/8'];
// console.log(isIPInWhitelist('192.168.1.1', whitelist)); // true
// console.log(isIPInWhitelist('10.0.1.5', whitelist));    // true
// console.log(isIPInWhitelist('172.16.0.1', whitelist));  // false
//
// 获取设备IP示例:
// getLocalIP().then(ip => console.log('当前设备IP:', ip))
//   .catch(err => console.error('获取IP失败:', err));